import { memo } from "react";

function PickupPopupMarker(props) {
  const shiftLeft = props.stopNo && props.stopNo < 10 ? 0 : -3;
  return (
    <svg
      width={24}
      height={24}
      viewBox={`0 0 24 24`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.5"
        y="1"
        width={21}
        height={22}
        rx="1.5"
        fill="none"
        stroke={props.color ?? '#ffffff'}
        strokeWidth={1}
      />
      <text
        id={8}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={12}
        fontWeight={500}
        fill={props.color ?? '#ffffff'}
      >
        <tspan x={7.5 + shiftLeft} y={16}>
          {props.stopNo}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(PickupPopupMarker);
